<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="edit-payment-page p-3">
    <!-- Header Section -->
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h4 class="mb-0 text-primary font-weight-bold">
        <b-icon icon="pencil-square" class="mr-2"></b-icon> ແກ້ໄຂຂໍ້ມູນການຈ່າຍ
      </h4>
      <b-button variant="outline-secondary" @click="goback" class="rounded-pill px-3 shadow-sm">
        <b-icon icon="arrow-left-circle" class="mr-1"></b-icon> ກັບຄືນ
      </b-button>
    </div>

    <b-form id="frm" name="frm" @submit="onSubmit" @reset="onReset" ref="frm">
      <b-row>
        <b-col lg="10" xl="8" class="mx-auto">
          <b-card no-body class="shadow-sm border-0 rounded-lg overflow-hidden bg-white">
            
            <!-- Section 1: Basic Info -->
            <div class="p-3 bg-light border-bottom">
              <h6 class="mb-0 text-muted font-weight-bold">
                <b-icon icon="info-circle" class="mr-2"></b-icon>ຂໍ້ມູນພື້ນຖານ
              </h6>
            </div>
            <div class="p-4">
              <b-row>
                <b-col md="6">
                  <b-form-group label="ສົກຮຽນ:">
                    <b-input-group>
                      <b-input-group-prepend is-text><b-icon icon="calendar3"></b-icon></b-input-group-prepend>
                      <b-form-input v-model="frm.accd" v-mask="'####-####'" placeholder="____-____" trim></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="ວັນທີ ເຂົ້າຂໍ້ມູນ:">
                    <b-form-datepicker required v-model="frm.creat_date" locale="lao" class="rounded"></b-form-datepicker>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="ລະຫັດໂຮງຮຽນ:">
                    <b-input-group>
                      <b-input-group-prepend is-text><b-icon icon="building"></b-icon></b-input-group-prepend>
                      <b-form-input v-model="frm.school_id" @input="getschoolname" required trim placeholder="ປ້ອນລະຫັດໂຮງຮຽນ"></b-form-input>
                    </b-input-group>
                    <small class="text-info mt-1 d-block font-weight-bold" v-if="schoolname">
                      <b-icon icon="check-circle" class="mr-1"></b-icon> {{ schoolname }}
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Section 2: Transaction Details -->
            <div class="p-3 bg-light border-top border-bottom">
              <h6 class="mb-0 text-muted font-weight-bold">
                <b-icon icon="list-check" class="mr-2"></b-icon>ລາຍລະອຽດທຸລະກຳ
              </h6>
            </div>
            <div class="p-4">
              <b-row>
                <b-col md="8">
                  <b-form-group label="ລາຍການ:">
                    <b-form-select v-model="frm.item_code" v-on:change="getItem" :options="items" class="rounded"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="ວັນທີທຸລະກຳ:">
                    <b-form-datepicker v-model="frm.trans_date" locale="lao" class="rounded"></b-form-datepicker>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group label="ຈຳນວນ:">
                    <vue-numeric v-model="frm.value" currency="" class="form-control text-right rounded" separator=","></vue-numeric>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="ຫົວໜ່ວຍ:">
                    <b-form-select v-model="frm.unit" :options="units" class="rounded"></b-form-select>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group label="ຈຳນວນເງິນ:">
                    <div class="amount-wrapper">
                      <vue-numeric v-model="frm.amount" currency="₭" currency-symbol-position="suffix" class="form-control text-right rounded-lg font-weight-bold text-success" separator=","></vue-numeric>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="ແຫຼ່ງທຶນ:">
                    <b-form-select v-model="frm.source_type" :options="source_types" class="rounded"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Footer Buttons -->
            <div class="p-4 bg-light border-top text-right">
              <b-button type="reset" variant="light" class="mr-2 px-4 rounded-pill border shadow-sm">
                <b-icon icon="x-circle" class="mr-1"></b-icon> ລ້າງຂໍ້ມູນ
              </b-button>
              <b-button type="submit" variant="primary" class="px-5 shadow rounded-pill font-weight-bold">
                <b-icon icon="save" class="mr-1"></b-icon> ບັນທຶກການແກ້ໄຂ
              </b-button>
            </div>

          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.frm.create_by = this.user.username
        this.frm.school_id=this.user.school_id
        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/source_types/source_type_desc/source_type", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_types = response.data;
            })

        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/items/item_desc_lao/item_code", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.items = response.data;
            })

            axios
            .get(this.$store.getters.getBaseUrl + "/getItems/units/unite_desc/unite_desc", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.units = response.data;
            })

            axios
            .get(this.$store.getters.getBaseUrl + "/getDocitem/payment_trans/_id/"+  this.$route.params.val, {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.frm = response.data[0];
            })
    },
    data() {
        return {
            user: [],
            source_types: [],
            items: [],
            fields: [
                { label: 'ລາຍການ', key: 'description', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ວັນທີ', key: 'trans_date', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນ', key: 'value', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ຫົວໜ່ວຍ', key: 'unit', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນເງີນ', key: 'amount', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                // { label: 'ແຫຼ່ງທືນ', key: 'source_type', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: '...', key: 'action', thClass: "  text-right", tdClass: " text-right" },
            ],
            item: {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            },
            frm: {
                "item_code": "",
                "creat_date": "",
                "create_by": "",
                "trans_date": "",
                "total": 0,
                "status": "N",
                "del_by": "",
                "del_date": "",
                "update_by": "",
                "update_date": "",
                "ref_no": "",
                "description": "",
                "school_id": "",
                "source_type": "GOV",
                "accd": "",
              //  "items": [],
                "value":0,
                "unit":"",
                "amount": 0,
                
            },
            schoolname: "",
            units:""
        }
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        getschoolname() {

            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/v_schools/school_id/" + this.frm.school_id, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.schoolname = response.data[0].school_name_lao +", ເມືອງ: "+response.data[0].district.district_name_lao +", ແຂວງ: "+response.data[0].province.prov_name;
                    } catch (error) {
                        this.schoolname = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        getItem() {
            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/items/item_code/" + this.item.item_code, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.item.description = response.data[0].item_desc_lao;
                    } catch (error) {
                        this.item.description = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        onSubmit(event) {
            event.preventDefault();
            // "update_by": "",
            //     "update_date": "",
            this.frm.update_by=this.user.username
            this.frm.update_date=new Date()
            this.frm.total=this.frm.amount
            let rp_data = null;
            // let sum = this.frm.items.reduce(function(total, currentValue) {
            //     //  console.log(currentValue.Y)
            //     return total + parseFloat(currentValue.amount);
            // }, 0);
            //     this.frm.total=sum
          let postsdata = {
                table: "payment_trans",
                rows: this.frm,
                pkey: "_id",
                wharevalue: this.$route.params.val

            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsonUpdate",
                    postsdata, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);

                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "ຂໍ້ວາມາແຈ້ງ.....",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })

                    } else {
                        //alert(rp_data.desc);
                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "Confirmation",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                    }
                });

        },
        onAdditem() {
            let row = {
                "trans_date": this.item.trans_date,
                "item_code": this.item.item_code,
                "description": this.item.description,
                "amount": this.item.amount,
                "source_type": this.item.source_type,
                "value": this.item.value,
                "unit": this.item.unit,
            }
            this.frm.items.push(row)
            this.item = {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            }
        },
        onRemoveItem(index) {
            this.frm.items.splice(index, 1)
        },
        total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
        onReset(event) {
        event.preventDefault()

            this.frm.items=[]

        }

    },

    computed: {
        Total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
    }

}
</script>

<style scoped>
.edit-payment-page {
  background-color: #f4f7f6;
  min-height: 100vh;
  font-family: 'Noto Sans Lao', sans-serif;
}

.rounded-lg {
  border-radius: 12px !important;
}

.amount-wrapper ::v-deep input {
  font-size: 1.25rem;
  background-color: #f0fff4 !important;
  border-color: #c6f6d5 !important;
}

.form-control:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.4rem;
}
</style>